import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from "chart.js";
import "chartjs-plugin-datalabels";

ChartJS.register(Tooltip, Legend, ArcElement);

const ReferencesPerOperationTypeDonutChart = ({ data, isLoading }) => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  });

  useEffect(() => {
    if (isLoading || !data || data.length === 0) {
      return; // Return early if data is not ready or not available
    }

    const counts = data.reduce((acc, item) => {
      const key = `${item.header.operation_type} - ${item.header.pedimento.pedimento_entry_point}`;
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

    // Sort counts in descending order
    const sortedCounts = Object.entries(counts).sort((a, b) => b[1] - a[1]);

    const labels = sortedCounts.map(([label]) => label);
    const dataPoints = sortedCounts.map(([, count]) => count);
    const backgroundColors = labels.map(
      (_, index) => `hsl(${220 + ((index * 30) % 360)}, 70%, 60%)`
    ); // Blue palette

    setChartData({
      labels: labels,
      datasets: [
        {
          data: dataPoints,
          backgroundColor: backgroundColors,
        },
      ],
    });
  }, [data, isLoading]);

  const options = {
    cutout: "50%",
    plugins: {
      legend: {
        position: "bottom",
      },
      datalabels: {
        anchor: "end",
        align: "end",
        backgroundColor: "rgba(173, 216, 230, 0.85)", // Light blue background
        borderRadius: 4,
        color: "#000",
        font: {
          weight: "bold",
        },
        formatter: (value, context) => {
          const total = context.chart._metasets[0].total;
          const percentage = ((value / total) * 100).toFixed(2) + "%";
          return `${
            context.chart.data.labels[context.dataIndex]
          }: ${percentage}`;
        },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          {isLoading ? (
            <FontAwesomeIcon
              icon={faSpinner}
              className="animate-spin text-blue-600 mr-2"
            />
          ) : null}
          References per Operation Type and Entry Point
        </h2>
      </div>
      <div className="flex-grow relative">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <FontAwesomeIcon
              icon={faSpinner}
              className="animate-spin text-xl"
            />
            <span className="ml-2 text-lg">Loading...</span>
          </div>
        ) : (
          <Doughnut data={chartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default ReferencesPerOperationTypeDonutChart;
